import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/exam_title.png'
import _imports_1 from '@/assets/currency/left.png'
import _imports_2 from '@/assets/currency/right.png'


const _withScopeId = n => (_pushScopeId("data-v-53906d4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = { class: "dvContent" }
const _hoisted_3 = { class: "dvTop" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeft" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftLogo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dvTopLeftLogoImg",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "dvTopLeftTitle ml1" }, "模拟测评")
], -1))
const _hoisted_5 = { class: "dvTopRightBtn" }
const _hoisted_6 = { class: "dvMid" }
const _hoisted_7 = { class: "dvMidTop" }
const _hoisted_8 = {
  key: 0,
  class: "dvCoverList"
}
const _hoisted_9 = { class: "dvCoverTitle mt30" }
const _hoisted_10 = { class: "dvCoverTitle mt20" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "dvMidBottom" }
const _hoisted_13 = { class: "dvpage" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dvImg",
  src: _imports_1
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "w50 colorF fontSize32" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dvImg",
  src: _imports_2
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "dvBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btnViewHistory",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToExamRecord && _ctx.goToExamRecord(...args)))
          }, " 查看历史记录 ")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.examThree.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.noMockExamTxt), 1)
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.examThree, (exam, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["dvCoverList", [index !== 0 ? 'ml24' : '']]),
                  key: exam.id
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(exam.name), 1),
                  _createElementVNode("button", {
                    class: "btnStartExam mt18",
                    onClick: ($event: any) => (_ctx.startExam(exam.id))
                  }, " 开始测评 ", 8, _hoisted_11)
                ], 2))
              }), 128))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "dvIcon",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)))
            }, _hoisted_15),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.current_page) + " / " + _toDisplayString(_ctx.total), 1),
            _createElementVNode("div", {
              class: "dvIcon",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            }, _hoisted_18)
          ])
        ], 512), [
          [_vShow, _ctx.examThree.length > 0]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "btnBack",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
        }, "返 回")
      ])
    ])
  ]))
}